module.exports = __webpack_public_path__ + "img/xiaomi-grejalica.742cfe55.svg";